import ajax from '@/libs/api.request'

export default {
    login: param => {
        return ajax.post("web/user/login", param);
    },
    getUserInfo:param => {
        return ajax.get("web/user/getUserInfo", param);
    },
    getList : param => {
        return ajax.get("edu/web/user/list", param);
    },
    save:param => {
        return ajax.post('edu/web/user/save',param)
    },
    getOne:param => {
        return ajax.get('edu/web/user/findOneById', param)
    },
    del:param => {
        return ajax.post('edu/web/user/delete', param)
    },
    getZoneList:param => {
        return ajax.get('edu/web/user/getZoneList', param)
    },
    editPwd:param => {
      return ajax.post('web/user/editPwd', param)
    },
}
